import createIcon from '../../createIcon';

/**
 * @component @name Airplay
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAyMS41SDE4TDEyIDE1LjVMNiAyMS41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxIDIuNUgzQzEuOSAyLjUgMSAzLjQgMSA0LjVWMTYuNUMxIDE3LjYgMS45IDE4LjUgMyAxOC41SDdWMTYuNUgzVjQuNUgyMVYxNi41SDE3VjE4LjVIMjFDMjIuMSAxOC41IDIzIDE3LjYgMjMgMTYuNVY0LjVDMjMgMy40IDIyLjEgMi41IDIxIDIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Airplay = createIcon('Airplay', [
  ['path', { d: 'M6 21.5H18L12 15.5L6 21.5Z', key: '1nnji' }],
  [
    'path',
    {
      d: 'M21 2.5H3C1.9 2.5 1 3.4 1 4.5V16.5C1 17.6 1.9 18.5 3 18.5H7V16.5H3V4.5H21V16.5H17V18.5H21C22.1 18.5 23 17.6 23 16.5V4.5C23 3.4 22.1 2.5 21 2.5Z',
      key: 'by6jpq',
    },
  ],
]);

export default Airplay;
